<template>
  <div
    class="form-group"
    :style="{ marginBottom }"
  >
    <img
      :src="require(small ? '../../../../../../resources/img/yandex-small.png' : '../../../../../../resources/img/yandex.png')"
      class="sengine"
      :class="{ 'img-muted': yandexDisabled, 'cursor-disabled': yandexDisabled }"
      alt="Yandex"
      @click="$emit('input', $getConst('SENGINE_YANDEX'))"
    >
    <label>
      <input
        v-model="value"
        type="radio"
        class="minimal"
        :value="$getConst('SENGINE_YANDEX')"
        :disabled="yandexDisabled"
        @click="$emit('input', $getConst('SENGINE_YANDEX'))"
      >
    </label>
    <img
      :src="require(small ? '../../../../../../resources/img/google-small.png' : '../../../../../../resources/img/google.png')"
      class="sengine"
      :class="{ 'img-muted': googleDisabled, 'cursor-disabled': googleDisabled }"
      alt="Google"
      @click="$emit('input', $getConst('SENGINE_GOOGLE'))"
    >
    <label>
      <input
        v-model="value"
        type="radio"
        class="minimal"
        :value="$getConst('SENGINE_GOOGLE')"
        :disabled="googleDisabled"
        @click="$emit('input', $getConst('SENGINE_GOOGLE'))"
      >
    </label>
  </div>
</template>

<script>/**
 * Выбор поисковой системы.
 */
import constants from '../../../../../../resources/js/constants'

export default {
  name: 'SengineSelect',
  props: {
    /**
     * @model
     */
    value: {
      type: String,
      validator (value) {
        return [
          constants.SENGINE_YANDEX,
          constants.SENGINE_GOOGLE
        ].includes(value)
      },
      required: true
    },
    /**
     * Доступен ли выбор поисковой системы Яндекс.
     */
    yandexDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Доступен ли выбор поисковой системы Google.
     */
    googleDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Маленькие изображения/логотипы.
     */
    small: {
      type: Boolean,
      default: false
    },
    marginBottom: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

img.sengine {
  padding-right: 10px;
}

.form-group {
  @media (max-width: $xsBreakpoint) {
    text-align: center;
  }
}
</style>
